import ButtonComponent from "../button";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./oauthConfig";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setUserData, setAllowedRoutes } from "../../redux/slices/userSlice";
import { getAvailableRoutesByRole } from "../../services/apiService";

const ActiveDirectoryIntegrationButton = () => {
  const navigate = useNavigate();
  const { instance } = useMsal();
  const dispatch = useDispatch();

  const handleLogin = async () => {
    try {
      const response = await instance.loginPopup(loginRequest);
      const idTokenClaims = response.idTokenClaims || {};
      const role = idTokenClaims?.roles?.[0];
      const userData = {
        name: idTokenClaims.name || idTokenClaims.preferred_username || "",
        email: idTokenClaims.preferred_username || idTokenClaims.email || "",
      };

      let routes = [];
      try {
        const res = await getAvailableRoutesByRole(role);
        routes = Array.isArray(res?.data) ? res.data : [];
      } catch (apiError) {
        console.warn("GetAvailableRoutesByRole no disponible, usando rutas por defecto:", apiError);
        routes = [
          "/BusinessUnit",
          "/PackagesView",
          "/Facturacion",
          "/Billing",
          "/additionalCost",
          "/reporteCostos",
          "/contador",
          "/Products",
          "/Packages",
        ];
      }

      localStorage.setItem("allowedRoutes", JSON.stringify(routes));
      localStorage.setItem("userData", JSON.stringify(userData));
      dispatch(setUserData(userData));
      dispatch(setAllowedRoutes(routes));

      if (routes.length > 0) {
        navigate(routes[0]);
      } else {
        navigate("/login");
      }
    } catch (error) {
      console.error(error);
      alert(error?.message || "Error al iniciar sesión con Microsoft.");
    }
  };

  return (
    <ButtonComponent
      type="button"
      onClick={handleLogin}
      variant="outlined"
      backgroundColor="#fff"
      textColor="#1976d2"
      margin="8px 0 0 0"
    >
      Iniciar sesión con Microsoft
    </ButtonComponent>
  );
};

export default ActiveDirectoryIntegrationButton;
